import 'jquery';

/**
 * toggle Loading behavior of forms
 */
(function ($) {
  let body = $('body');

  $(document).on('submit', 'form', function () {
    let form = $(this);
    window.setTimeout(function () {
      form.find(':submit')
        .prop('disabled', true)
        .addClass('loading');
      if (form.data('processing')) {
        body.trigger('plenigo.processing');
      } else {
        body.trigger('plenigo.loading');
      }
    }, 100);
  }).on('plenigo.reset', 'form', function () {
    $(this).find(':submit')
      .prop('disabled', false)
      .removeClass('loading');
    body.trigger('plenigo.removeLoading');
  });

}(jQuery));

/**
 * pimp placeholder fields in select
 */
(function ($) {

  $('select[data-has-placeholder][required]').each(function () {
    var placeholder = $($(this).children('option')[0]);
    let form = $(this).closest('form'),
      text = placeholder.text();

    placeholder
      .addClass('placeholder')
      .text(text + ' *')
      .prop('disabled', false);

    form.on('submit', function () {
      placeholder.prop('disabled', true);
    });

  });

}(jQuery));

/**
 * Handling reloading in Waiting screen
 */
(function ($) {

  let refreshUrl = $('body#wait').data('wait'),
    round = parseInt($('body#wait').data('round') || 1, 10);

  if (refreshUrl) {
    window.setTimeout(function () {
      location.href = refreshUrl;
    }, 2000 * (round || 1));
  }

}(jQuery));

/**
 * remove errors from forms and input elements
 */
(function ($) {

  $('body').on('keyup', ':input', function () {
    // remove input error
    $(this).removeClass('is-invalid');
    // hide form error
    $('#errorMessage').removeClass('has_errors');
  });

}(jQuery));

/**
 * trigger resize on every toggle button
 */
(function ($, document) {

  $('body').on('shown.bs.collapse hidden.bs.collapse', function () {
    $(document).trigger('plenigo.resize');
  });

}(jQuery, document));
